import { sygnet } from "./sygnet";
import { logo } from "./logo";
import { logoNegative } from "./logo-negative";

import {
  cilAlignCenter,
  cilAlignLeft,
  cilAlignRight,
  cilApplicationsSettings,
  cilArrowBottom,
  cilArrowRight,
  cilArrowTop,
  cilAsterisk,
  cilSmile,
  cilBan,
  cilBasket,
  cilBell,
  cilBold,
  cilBookmark,
  cilCalculator,
  cilCopy,
  cilCalendar,
  cilClipboard,
  cilCloudDownload,
  cilCloudUpload,
  cilClock,
  cilChartPie,
  cilCheck,
  cilChevronBottom,
  cilChevronLeft,
  cilChevronRight,
  cilChevronTop,
  cilCircle,
  cilCheckCircle,
  cilCode,
  cilCommentSquare,
  cilCreditCard,
  cilCursor,
  cilCursorMove,
  cilDrop,
  cilDollar,
  cilEnvelopeClosed,
  cilEnvelopeLetter,
  cilEnvelopeOpen,
  cilEuro,
  cilEyedropper,
  cilFile,
  cilFullscreen,
  cilFullscreenExit,
  cilGlobeAlt,
  cilGrid,
  cilGraph,
  cilHome,
  cilInbox,
  cilMenu,
  cilMinus,

  cilIndentDecrease,
  cilIndentIncrease,
  cilInputPower,
  cilItalic,
  cilInfo,
  cilJustifyCenter,
  cilJustifyLeft,
  cilLaptop,
  cilLibraryBuilding,
  cilLayers,
  cilLightbulb,
  cilList,
  cilListNumbered,
  cilListRich,
  cilLocationPin,
  cilLockLocked,
  cilMagnifyingGlass,
  cilMap,
  cilMoon,
  cilNotes,
  cilOptions,
  cilPaperclip,
  cilPaperPlane,
  cilPen,
  cilPencil,
  cilPeople,
  cilPhone,
  cilPrint,
  cilPuzzle,
  cilSave,
  cilScrubber,
  cilSettings,
  cilShare,
  cilShareAll,
  cilShareBoxed,
  cilShieldAlt,
  cilSpeech,
  cilSpeedometer,
  cilSpreadsheet,
  cilStar,
  cilSun,
  cilTags,
  cilTask,
  cilTrash,
  cilUnderline,
  cilUser,
  cilUserFemale,
  cilUserFollow,
  cilUserUnfollow,
  cilX,
  cilXCircle,
  cilWarning,
  cilPlus,
  cilUserPlus,
  cilBellExclamation,
  cilVolumeHigh,
  cilBrush,
  cilBook,
  cilBriefcase,
  cilBrowser,
  cilDelete,
  cilImagePlus,
  cilAddressBook,
  cilOpentype,
  cilVerticalAlignTop,
  cilPenNib,
  cilAlarm,
  cilBarChart,
  cilLoopCircular,
  cilCheckAlt,
  cilChevronCircleDownAlt,
  cilChevronCircleUpAlt,
  cilFolder,
  cilFolderOpen,
  cilChartLine,
  cilColorBorder,
  cilSearch,
  cilZoom,
  cilArrowLeft,
  cilTag,
  cilNoteAdd,
  cilImage,
  cilLink,
  cilSend,
  cilMoodBad,

} from "@coreui/icons";

export const icons = Object.assign(
  {},
  {
    sygnet,
    logo,
    logoNegative,
  },
  {
    cilSmile,
    cilMoodBad,
    cilLink,
    cilImage,
    cilNoteAdd,
    cilTag,
    cilArrowLeft,
    cilSearch,
    cilZoom,
    cilAlignCenter,
    cilAlignLeft,
    cilAlignRight,
    cilApplicationsSettings,
    cilArrowBottom,
    cilArrowRight,
    cilArrowTop,
    cilAsterisk,
    cilBan,
    cilBasket,
    cilBell,
    cilBold,
    cilBookmark,
    cilCalculator,
    cilCopy,
    cilClock,
    cilCalendar,
    cilClipboard,
    cilCloudDownload,
    cilCloudUpload,
    cilChartPie,
    cilCheck,
    cilChevronBottom,
    cilChevronLeft,
    cilChevronRight,
    cilChevronTop,
    cilCircle,
    cilCheckCircle,
    cilCode,
    cilCommentSquare,
    cilCreditCard,
    cilCursor,
    cilCursorMove,
    cilDrop,
    cilDollar,
    cilEnvelopeClosed,
    cilEnvelopeLetter,
    cilEnvelopeOpen,
    cilEuro,
    cilEyedropper,
    cilFile,
    cilFullscreen,
    cilFullscreenExit,
    cilGlobeAlt,
    cilGrid,
    cilGraph,
    cilMenu,
    cilHome,
    cilInbox,
    cilIndentDecrease,
    cilIndentIncrease,
    cilInputPower,
    cilInfo,
    cilItalic,
    cilJustifyCenter,
    cilJustifyLeft,
    cilLaptop,
    cilLayers,
    cilLightbulb,
    cilList,
    cilListNumbered,
    cilLibraryBuilding,
    cilListRich,

    cilLocationPin,
    cilLockLocked,
    cilMagnifyingGlass,
    cilMap,
    cilMinus,
    cilMoon,
    cilNotes,
    cilOptions,
    cilPaperclip,
    cilPaperPlane,
    cilPen,
    cilPencil,
    cilPeople,
    cilPhone,
    cilPrint,
    cilPuzzle,
    cilSave,
    cilScrubber,
    cilSettings,
    cilShare,
    cilShareAll,
    cilShareBoxed,
    cilShieldAlt,
    cilSpeech,
    cilSpeedometer,
    cilSpreadsheet,
    cilStar,
    cilSun,
    cilTags,
    cilTask,
    cilTrash,
    cilLockLocked,
    cilUnderline,
    cilUser,
    cilUserFemale,
    cilUserFollow,
    cilUserUnfollow,
    cilX,
    cilXCircle,
    cilWarning,
    cilPlus,
    cilUserPlus,
    cilBellExclamation,
    cilVolumeHigh,
    cilBrush,
    cilBook,
    cilBriefcase,
    cilBrowser,
    cilDelete,
    cilImagePlus,
    cilAddressBook,
    cilOpentype,
    cilVerticalAlignTop,
    cilPenNib,
    cilAlarm,
    cilBarChart,
    cilLoopCircular,
    cilCheckAlt,
    cilChevronCircleDownAlt,
    cilChevronCircleUpAlt,
    cilFolder,
    cilFolderOpen,
    cilChartLine,
    cilColorBorder,
    cilSend,
  }
);
